//import api from "../../api";

/**
 * Este metodo es un helper para agregar busqueda a cada
 * tab de Mis Solicitudes.
 * @param {Object} state El estado del module
 * @param {Object} request La solicitud a procesar
 */
const __searchItems = (state, request) => {
  // Campos de request
  const keys = state.mapKeys;
  // Valor a buscar
  const query = state.search;
  // Si es true el query fue encontrado
  let flag = false;

  // Esto es el bucle de busqueda.
  for (let i1 = 0; keys.length; i1++) {
    const col = keys[i1];
    let value = request[col];

    if (value === undefined) {
      return;
    }

    const valueType = typeof value;

    if (valueType === "number" || valueType === "decimal") {
      value = value.toString();
      if (value.indexOf(query) > -1) {
        flag = true;
        break;
      }
    } else {
      if (value !== null) {
        if (Number.isNaN(value)) {
          if (value.indexOf(query) > -1) {
            flag = true;
            break;
          }
        }

        if (
          valueType === "string" &&
          value.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1
        ) {
          flag = true;
          break;
        }
      }
    }
  }

  return flag;
};

const __helperItems = (state, rootState, requestsR = [], my = false) => {
  const user = rootState.user.user;
  return requestsR.filter((request) => {
    // Las creadas por el user, pendiente por validar
    if (my === true) {
      return request.CreateById === user.EmployeeId;
    }

    const flagSearch = state.search !== "";
    const flagFilterByEmployee = state.byEmployeeId !== 0;

    if (state.byDirectionId !== 0) {
      return request.DirecctionID === state.byDirectionId;
    }

    if (flagFilterByEmployee) {
      return request.ResponsableID === state.byEmployeeId;
    }

    // Esta vandera solo puede ser activado por el ceo o super user.
    if (state.allMyRequests) {
      if (!flagSearch) return true;

      return __searchItems(state, request);
    }

    // Verdadero: las asignadas y las que el user es supervisor
    if (!state.swichMyRequest) {
      return (
        (request.ResponsableID === user.EmployeeId ||
          request.SupervisorID === user.EmployeeId) &&
        (flagSearch ? __searchItems(state, request) : true)
      );
    }
    // False: las que son creadas por el user
    else {
      return (
        request.CreateById === user.EmployeeId &&
        (flagSearch ? __searchItems(state, request) : true)
      );
    }
  });
};

const state = {
  myRequest: [],
  myRequestDB: {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: []
  },
  swichMyRequest: true,
  tabActiveName: "new",
  byEmployeeId: 0,
  byDirectionId: 0,
  allMyRequests: false,
  search: "",
  mapKeys: {},
  loading: false,
  sectionSelected: "request",
  userTypeInInternalRequest: "",
  mushu: {},
  pageConfig: {
    limit: 10,
    skip: 0,
    page: 1
  }
};

const getters = {
  myRequestInProgressCount(state) {
    return state.mushu.EnProgreso;
  },
  myRequestInClosedCount(state) {
    return state.mushu.PorValidar;
  },
  myRequestCancellCount(state) {
    return state.mushu.Canceladas;
  },
  myRequestCompletedCount(state) {
    return state.mushu.Completadas;
  },
  myRequestAllCount(state) {
    return state.mushu.Todas;
  },

  myRequestNewCount(state) {
    return state.mushu.Nuevas;
  },

  myRequestNew: (state, getters, rootState) => {
    return __helperItems(state, rootState, state.myRequestDB[0]);
  },

  myRequestInProgress: (state, getters, rootState) => {
    return __helperItems(state, rootState, state.myRequestDB[1]);
  },

  myRequestInClosed: (state, getters, rootState) => {
    return __helperItems(state, rootState, [
      ...state.myRequestDB[2],
      ...state.myRequestDB[3]
    ]);
  },

  myRequestCancell: (state, getters, rootState) => {
    return __helperItems(state, rootState, state.myRequestDB[4]);
  },

  myRequestCompleted: (state, getters, rootState) => {
    return __helperItems(state, rootState, state.myRequestDB[5]);
  },

  myRequestAll: (state, getters, rootState) => {
    return __helperItems(state, rootState, state.myRequestDB[10]);
  },

  //getter conteo de solicitudes nuevas para supervisor o responsable
  // myRequestNewCount: (state, getters, rootState) => {
  //   let requests = state.myRequestDB[0];
  //   const user = rootState.user.user;
  //   if (user.isSupervisor) {
  //     return requests.filter(r => r.SupervisorID === user.EmployeeId).length;
  //   }
  //   return requests.filter(
  //     r =>
  //       r.ResponsableID === user.EmployeeId ||
  //       (r.CreateById === user.EmployeeId && r.ResponsableID === 0)
  //   ).length;
  // },
  getUserTypeInternalRequest: (state) => state.userTypeInInternalRequest,
  myRequestInClosedCount2: (state, getters, rootState) => {
    const user = rootState.user.user;
    const r = [...state.myRequestDB[2], ...state.myRequestDB[3]];
    return r.filter((f) => f.CreateById === user.EmployeeId).length;
  }
};

const actions = {
  // fetchMyRequests: ({ commit, rootState }) => {
  //   return new Promise((resolve, reject) => {
  //     commit("TOGGLE_LOADING");
  //     const user = rootState.user.user;
  //     const isSupervisor = user.IsSupervisor;
  //     let url = "";
  //     if (!isSupervisor) {
  //       url =
  //         "/api/InternalServiceRequest/GetListInternalServiceRequestByResponsable/";
  //     } else {
  //       url =
  //         "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisor/";
  //     }
  //     const params = {
  //       personID: user.EmployeeId,
  //       company: user.CompanySelected
  //     };
  //     api
  //       .get(url, {
  //         params: params
  //       })
  //       .then(response => {
  //         const data = response.data;
  //         commit("SET_MAP_KEYS", Object.keys(data[0]));
  //         const requests = data.reverse();
  //         commit("SET_MY_REQUEST", requests);
  //         const myRequestDB = {
  //           10: requests,
  //           0: requests.filter(f => f.Status === 0),
  //           1: requests.filter(f => f.Status === 1),
  //           2: requests.filter(f => f.Status === 2),
  //           3: requests.filter(f => f.Status === 3),
  //           4: requests.filter(f => f.Status === 4),
  //           5: requests.filter(f => f.Status === 5)
  //         };
  //         commit("SET_MY_REQUEST_DB", myRequestDB);
  //         resolve(response.data);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       })
  //       .finally(() => commit("TOGGLE_LOADING"));
  //   });
  // }
};

const mutations = {
  SET_COUNT(state, payload) {
    state.mushu = payload;
  },

  SET_MY_REQUEST: (state, request) => {
    state.myRequest = request;
  },
  ADD_COMMENT: (state, { myRequestId, comment, statusId }) => {
    const requests = state.myRequestDB[statusId];
    const myRequest = requests.find((f) => f.Id === myRequestId);

    if (myRequest !== undefined) {
      myRequest.Activities.unshift(comment);
    }
  },
  SET_STATUS: (state, { myRequestId, statusId, beforeId }) => {
    const before = state.myRequestDB[beforeId];
    if (before !== undefined) {
      const bIndex = before.findIndex((f) => f.Id === myRequestId);
      if (bIndex !== -1) {
        const myRequest = JSON.parse(JSON.stringify(before[bIndex]));
        myRequest.Status = statusId;

        before.splice(bIndex, 1);

        const newStatus = state.myRequestDB[statusId];
        if (newStatus !== undefined) {
          newStatus.unshift(myRequest);
        } else {
          throw new Error("Lista de estados no existe");
        }
      }
    } else {
      throw new Error("Lista de estados no existe");
    }
  },
  SET_VALIDATE: (state, { myRequestId, statusId }) => {
    const requests = state.myRequestDB[statusId];
    const myRequestIndex = requests.findIndex((f) => f.Id === myRequestId);
    const myRequest = requests.find((f) => f.Id === myRequestId);

    if (myRequest) {
      myRequest.Validated = true;
      myRequest.Status = 3;
      myRequest.Valoracion = 0;

      requests.splice(myRequestIndex, 1);

      state.myRequestDB[3].unshift(myRequest);
    }
  },
  SET_VALORATION: (state, { myRequestId, rate, statusId }) => {
    const requests = state.myRequestDB[statusId];
    const myRequestIndex = requests.findIndex((f) => f.Id === myRequestId);
    const myRequest = requests.find((f) => f.Id === myRequestId);

    if (myRequest) {
      myRequest.Status = 5;
      myRequest.Valoracion = rate;

      requests.splice(myRequestIndex, 1);
      state.myRequestDB[5].unshift(myRequest);
    }
  },
  ADD_MY_REQUEST: (state, { statusId, myRequest }) => {
    if (state.myRequestDB[statusId] === undefined) {
      state.myRequestDB[statusId] = [];
    }

    state.myRequestDB[statusId].unshift(myRequest);
  },
  TOGGLE_GET_MY_REQUEST: (state) => {
    state.swichMyRequest = !state.swichMyRequest;
  },
  SET_TAB_ACTIVE_SECTION_NAME: (state, status) => {
    state.sectionSelected = status;
  },
  SET_TAB_ACTIVE_NAME: (state, status) => {
    state.tabActiveName = status;
  },
  SET_MY_REQUEST_DB: (state, payload) => {
    state.myRequestDB = payload;
  },
  SET_VAL_COMMENT: (state, { myRequestId, comment, statusId }) => {
    const requests = state.myRequestDB[statusId];
    const myRequest = requests.find((f) => f.Id === myRequestId);

    if (myRequest) {
      myRequest.ComentarioValoracion = comment;
    }
  },
  SET_BY_EMPLOYEE_ID: (state, employeeId) => {
    state.byEmployeeId = employeeId;
  },
  SET_USER_TYPE_INTERNAL_REQUEST: (state, rootState, typeUser) => {
    const user = rootState.user.user;
    if (user.EmployeeId === 37) {
      state.userTypeInInternalRequest = typeUser;
    }
  },
  SET_BY_DIRECCTION_ID: (state, directionId) => {
    state.byDirectionId = directionId;
  },
  SET_ALL_MY_REQUESTS: (state, allMyRequests) => {
    state.allMyRequests = allMyRequests;
  },
  SET_SEARCH: (state, search) => {
    state.search = search;
  },
  SET_MAP_KEYS: (state, mapKeys) => {
    state.mapKeys = mapKeys;
  },
  TOGGLE_LOADING: (state) => {
    state.loading = !state.loading;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
